module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"title":"Scegli una e-mail","info":"Quale indirizzo mail vuoi utilizzare? Clicca su quello che desideri oppure aggiungi una nuova e-mail.","addMail":"Nuova e-mail","loadingTitle":"Caricamento e-mail","loadingSubtitle":"L\u0027operazione dovrebbe richiedere qualche istante"}}')
  delete Component.options._Ctor
}
